const dummyCoins = {
  USDC: "0xf3D16db53cFCee5d26EE29cDeeaa49215A21d345",
  UNI: "0x3E1722c57f5439b5279bA7Bd9Db37f667eAF2Bc9",
  WETH: "0x5E4921e55D88f1E61AcD35adE5cAfce3F3FcA7a6",
};

export { dummyCoins };
